import {Component, Inject, Vue, Watch} from "vue-property-decorator";
import {MainContainer} from "~/components/main-container";
import {PageTitle} from "~/components/page-title";
import {ClientNavigationTabs, ClientTab} from "~/modules/client/compponents/navigation-tabs";
import {ClientProfile} from "~/modules/client/compponents/profile";
import {ClientSubscription} from "~/modules/client/compponents/subscription";
import {Getter} from "vuex-class";
import {icons} from "~/components/icon";
import {Loader} from "~/components/loader";
import {AppSettings} from "~/lib/app-settings";

@Component
export class ClientView extends Vue {

  @Inject() appSettings: AppSettings;
  @Getter currentUser;

  private isLoading:boolean = false;
  private currentTab: ClientTab = ClientTab.Profile;

  async created(){
    !this.client && (this.isLoading = true);
  }

  get client() {
    return this.appSettings.client;
  }

  @Watch('client')
  onClientLoaded() {
    this.isLoading = false;
  }

  renderContent(){

    if (this.isLoading) {
      return <Loader/>;
    }

    switch(this.currentTab){
      case ClientTab.Profile :
        return <ClientProfile client={this.client} />;
      case ClientTab.Subscription:
        return <ClientSubscription client={this.client} />;
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.user} title="Profil Client"/>
        <ClientNavigationTabs v-model={this.currentTab} />
        <div class="page-content">
          {this.renderContent()}
        </div>
      </MainContainer>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-32131524/client-view.tsx" });